var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import FormattedMessage, { injectIntl } from "@irati/utils/lang";
import { Checkbox } from "@irati/ui/src/FormItem";
import Form from "@irati/ui/src/Form";
import Validation from "@irati/utils/validation";
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: 40px;\n"], ["\n  margin-bottom: 40px;\n"])));
var CheckboxContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin-top: 30px;\n  .form-group {\n    margin-bottom: 0px;\n  }\n"], ["\n  margin-top: 30px;\n  .form-group {\n    margin-bottom: 0px;\n  }\n"])));
var agreeSchema = function (formatMessage) {
    return Validation.bool().oneOf([true], formatMessage({ id: "perks.components.productForms.timeLimited.agree.error" }));
};
var TimeLimitedDeal = /** @class */ (function (_super) {
    __extends(TimeLimitedDeal, _super);
    function TimeLimitedDeal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            agree: false
        };
        _this.handleChange = function () { return _this.setState(function (_a) {
            var agree = _a.agree;
            return ({ agree: !agree });
        }); };
        return _this;
    }
    TimeLimitedDeal.prototype.render = function () {
        return (React.createElement(Container, null,
            React.createElement(FormattedMessage, { id: "perks.components.productForms.timeLimited.body" }),
            React.createElement(CheckboxContainer, null,
                React.createElement(Form, null,
                    React.createElement(Checkbox, { name: "agreeTo24HoursLimit", validation: agreeSchema(this.props.formatMessage), checked: this.state.agree, onChange: this.handleChange },
                        React.createElement(FormattedMessage, { id: "perks.components.productForms.timeLimited.agree.label" }))))));
    };
    return TimeLimitedDeal;
}(PureComponent));
export default injectIntl(TimeLimitedDeal);
var templateObject_1, templateObject_2;
